import { getheader, postMethodByCallBack, serverUrl, setErrorDialog, translateError } from "./CommonFunctions";

export function addNewReminder(data, fn) {
    return dispatch => {
        fetch(serverUrl + "api/ReminderAPI/AddNewReminder", {
            headers: getheader(),
            body: JSON.stringify(data),
            method: "POST"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, "ثبت یادآوری");
                    return;
                }
                setErrorDialog(dispatch, "success", "ثبت یادآوری");
                if (fn) {
                    fn(res);
                }
            })
    }
}
export function editReminder(data, fn) {
    return dispatch => {
        fetch(serverUrl + "api/ReminderAPI/EditReminder", {
            headers: getheader(),
            body: JSON.stringify(data),
            method: "POST"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, "ویرایش یادآوری");
                    return;
                }
                setErrorDialog(dispatch, "success", "ویرایش یادآوری");
                if (fn) {
                    fn(res);
                }
            })
    }
}
export function readReminder(id, fn) {
    return dispatch => {
        fetch(serverUrl + "api/ReminderAPI/ReadReminder", {
            headers: getheader(),
            body: id,
            method: "POST"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, "ثبت یادآوری");
                    return;
                }
                setErrorDialog(dispatch, "success", "ثبت یادآوری");
                if (fn) {
                    fn(res);
                }
            })
    }
}
export function getReminder(id, fn) {
    return dispatch => {
        fetch(serverUrl + "api/ReminderAPI/GetReminder", {
            headers: getheader(),
            body: id,
            method: "POST"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, "دریافت یادآوری");
                    return;
                }
                if (fn) {
                    fn(res);
                }
            })
    }
}
export function deleteReminder(id, fn) {
    return dispatch => {
        fetch(serverUrl + "api/ReminderAPI/DeleteReminder", {
            headers: getheader(),
            body: id,
            method: "POST"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, "حذف یادآوری");
                    return;
                }
                setErrorDialog(dispatch, "success", "حذف یادآوری");
                if (fn) {
                    fn(res);
                }
            })
    }
}
export function searchUnreadReminders(skip, onGetData) {
    let data = {};
    data.MyReminders = true;
    data.AlarmDateTo = new Date();
    data.IsRead = false;
    data.Take = 10;
    data.Skip = skip;
    return dispatch => {
        // dispatch({
        //     type: "SEARCH_UNREAD_REMINDERS",
        //     data: "PENDING"
        // });
        onGetData?.("PENDING");
        let token = localStorage.getItem("token");
        let sUrl = localStorage.getItem("ServerUrl");
        if (!token || !sUrl) {
            // dispatch({
            //     type: "SEARCH_UNREAD_REMINDERS",
            //     data: []
            // });
            onGetData?.([]);
            return;
        }
        fetch(sUrl + "api/ReminderAPI/SearchReminders", {
            headers: getheader(),
            body: JSON.stringify(data),
            method: "POST"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, "دریافت یادآوری ها");
                    res.Data = null;
                }
                // dispatch({
                //     type: "SEARCH_UNREAD_REMINDERS",
                //     data: res
                // });
                onGetData(res);
            }).catch(e => console.log("[SEARCH_UNREAD_REMINDERS]", e))
    }
}
export function searchReminders(data, onGetData) {
    let token = localStorage.getItem("token");
    let sUrl = localStorage.getItem("ServerUrl");
    if (!token || !sUrl) {
        return dispatch => {
            dispatch({
                type: "SEARCH_UNREAD_REMINDERS",
                data: []
            });
        }
    }
    onGetData('PENDING');
    fetch(serverUrl + "api/ReminderAPI/SearchReminders", {
        headers: getheader(),
        body: JSON.stringify(data),
        method: "POST"
    }).then(res => res.json())
        .then(res => {
            if (res.Message) {
                res.Error = translateError(res.Message);
                res.Data = null;
            }
            onGetData(res);
        }).catch(e => console.log("[SEARCH_REMINDERS]", e))
}
export function setReminderPop(status) {
    return dispatch => {
        return dispatch({
            type: "REMINDER_POP",
            data: status
        });
    }
}
export function getMyRemindersCount(fn) {
    fetch(serverUrl + "api/ReminderAPI/GetMyRemindersCount", {
        headers: getheader(),
        cache: "default",
        method: "GET"
    }).then(res => res.json())
        .then(res => {
            if (fn) {
                fn(res);
            }
        })
}
export function postponeReminder(id, date, onDone) {
    postMethodByCallBack(`api/ReminderAPI/PostponeReminder?id=${id}`, date, onDone, "PostponeReminder");
}